import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../css/OTPPage.css";
import dogCatImage from "../assets/view-cats-dogs-showing-friendship 1.png";

const OTPPage = () => {
  const inputsRef = useRef([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (!/^\d$/.test(value)) {
      e.target.value = ""; // clear non-numeric input
      return;
    }

    // Move to next input
    if (index < 4 && inputsRef.current[index + 1]) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleVerify = () => {
    const code = inputsRef.current.map((input) => input.value).join("");
    const hasEmpty = inputsRef.current.some((input) => input.value.trim() === "");

    if (hasEmpty || code.length !== 5) {
      setError(true);
    } else {
      setError(false);
      navigate("/password-reset");
    }
  };

  return (
    <div className="otp-login-container">
      <div className="otp-login-left">
        <h2 className="otp-login-left-header">
          Reset Your Password – Reconnect With Your Pet’s World!
        </h2>
        <img className="otp-image" src={dogCatImage} alt="Dog and Cat" />
      </div>

      <div className="otp-login-right">
        <h2 className="otp-login-right-header">Check your email</h2>
        <p className="otp-instruction">
          We sent a reset link to designer...@gmail.com <br />
          Enter 5 digit code that was mentioned in the email
        </p>

        <div className="otp-inputs">
          {[...Array(5)].map((_, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              ref={(el) => (inputsRef.current[index] = el)}
              inputMode="numeric"
              pattern="[0-9]*"
              className={error ? "otp-input-error" : ""}
            />
          ))}
        </div>

        {error && <p className="otp-error-text">Please enter valid verify code</p>}

        <button className="otp-verify-btn" onClick={handleVerify}>
          Verify Code
        </button>

        <p className="otp-resend-text">
          Haven't got the email yet?{" "}
          <span>
            <Link to="/forgot-password">Resend email</Link>
          </span>
        </p>
      </div>
    </div>
  );
};

export default OTPPage;